







































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import IcoachLocalStorageHelper from '@/utils/IcoachLocalStorageHelper'
import { IcoachData, IcoachGeneralInfo, IcoachCategorySkill, IcoachSkill, MainLogosTypes } from '@/interfaces'
import IcoachService from '@/services/IcoachService'
import IcoachSkillSection from '@/components/icoach/IcoachSkillSection.vue'
import IcoachSkillList from '@/components/icoach/IcoachSkillList.vue'
import { BreadcrumbElement } from '@/interfaces/BreadcrumbsInterfaces'
import IcoachHelper from '@/utils/IcoachHelper'
import AppFooter from '@/components/footer/AppFooter.vue'

@Component({
  name: 'IcoachSkillPage',
  components: {
    IcoachSkillSection,
    IcoachSkillList,
    AppFooter
  }
})
export default class IcoachSkillPage extends Vue {
  @Prop({ required: true })
  icoachUserId!: number
  @Prop({ required: true })
  skillId!: number
  @Prop({ required: true })
  stepId!: number

  @Getter('icoach/getIcoachInfo')
  icoachInfo!: IcoachGeneralInfo | null

  @Watch('skillId')
  onIcoachUserIdChanged () {
    this.loadData()
  }

  icoachUserData: IcoachData | null = null
  icoachSkill: IcoachSkill | null = null
  displaySkill: boolean = false
  icoachSkillStep: number = 0
  icoachSkillCategoryInfo: IcoachCategorySkill | null = null
  error: string | null = null
  icoachTitle: string = ''

  async created () {
    if (!IcoachLocalStorageHelper.hasIcoachUser(this.icoachUserId) ||
      !(this.icoachUserData = IcoachLocalStorageHelper.getIcoachUser(this.icoachUserId))
    ) {
      this.$router.push({ name: 'notFound' })

      return
    }

    this.icoachTitle = this.icoachUserData.icoachCourseTitle

    if (this.icoachInfo === null && this.icoachUserData.icoachAccessCode) {
      const response = await IcoachService.getIcoachCourseInfo(this.icoachUserData.icoachAccessCode)

      this.$store.commit('mainLogo/setLogos', response.logos)
      this.$store.commit('mainLogo/setType', MainLogosTypes.ICOACH_LOGOS)
      this.$store.commit('icoach/setIcoachInfo', {
        'userId': this.icoachUserId,
        'icoachCourse': response
      })
    }

    if (this.icoachInfo === null) {
      return
    }

    try {
      IcoachHelper.checkIcoachCourse(this.icoachInfo.icoachCourse)
    } catch (error) {
      this.error = error.message
      return
    }

    this.loadData()
  }

  async loadData (): Promise<void> {
    await this.uploadIcoachSkillInfo()

    this.icoachSkillStep = this.stepId
    this.displaySkill = true
  }

  get breadcrumbsData (): BreadcrumbElement[] {
    return [
      {
        name: this.icoachUserData!.icoachCourseTitle,
        link: { name: 'icoach.welcome', params: { accessCode: this.icoachUserData && this.icoachUserData.icoachAccessCode ? this.icoachUserData.icoachAccessCode : '' } }
      },
      {
        name: this.$t(`icoach.categories.${this.icoachUserData!.icoachSkillCategoryId}`),
        link: { name: 'icoach.dashboard', params: { icoachUserId: this.icoachUserId.toString() } }
      },
      {
        name: this.icoachSkill ? this.icoachSkill.name : ''
      }
    ]
  }

  async uploadIcoachSkillInfo (): Promise<void> {
    if (!this.icoachUserData || !this.icoachUserData.icoachAccessCode) {
      throw new Error()
    }

    try {
      this.icoachSkill = await IcoachService.getIcoachSkillInfo(this.icoachUserData.icoachAccessCode, this.skillId)

      const icoachSkillCategoryInfo = await IcoachService.getIcoachSkillCategory(
        this.icoachUserData.icoachCourseId,
        this.icoachUserData.icoachUserId,
        this.icoachSkill.category
      )

      this.$store.commit('icoach/setIcoachSkill', this.icoachSkill)
      this.$store.commit('icoach/setIcoachSkillMenu', icoachSkillCategoryInfo)
    } catch (e) {
      this.$router.push({ name: 'notFound' })
    }

    this.$store.commit('icoach/setIcoachSkillStepId', 1)
  }

  pushToAnotherStep (stepId: number) : void {
    this.icoachSkillStep = stepId
  }
}
